
import Dth from "../../components/dth/Dth"
export const DTHpage = ({ title_1, title_2, title }) => {
   
    return <div>
        <Dth title_1={title_1} title_2={title_2} title={title} />
    </div>
}